import '../../toolForm.css';
import { Input } from 'antd';
import React from 'react';

import type { toolInput } from '../../../interfaces';
import type { FormInstance } from 'antd';

const NumberInput: React.FC<{
  input: toolInput;
  form: FormInstance<any>;
  onValueChange?: (value: string) => void;
}> = ({ input, form, onValueChange }) => (
  <Input
    name={input.name}
    value={form.getFieldValue(input.name)}
    placeholder={''}
    allowClear
    autoComplete="on"
    onChange={(e) => {
      form.setFieldValue(input.name, e.target.value);
      if (onValueChange) {
        onValueChange(input.name);
      }
    }}
    style={{
      maxWidth: '600px',
    }}
  />
);

export { NumberInput };
